import { Offcanvas } from 'react-bootstrap'
import { OffcanvasPlacement } from 'react-bootstrap/esm/Offcanvas'

interface IProps {
  width?: string
  show: boolean
  handleClose: () => void
  placement: OffcanvasPlacement
  header: JSX.Element
  children?: JSX.Element
  props?: any
  bodyOverflow?: any
}

export const Drawer = ({ width, show, handleClose, header, children, placement, ...props }: IProps) => {
  return (
    <>
      <Offcanvas show={show} onHide={handleClose} placement={placement} {...props} style={{ width: width }}>
        {header}
        <Offcanvas.Body>{children}</Offcanvas.Body>
      </Offcanvas>
    </>
  )
}
